
import { LanguageCode, LanguageCodes } from "../../DTOs";
import { basicValidation } from './basicValidation';

export const languageValidation = {
    validateLanguageCode,
    validateLanguageCodeList,
    validateLanguageCodeLists,

    // TODO: Remove these 3
    validateTranslationLanguage,
    validateTranslationLanguageList,
    validateTranslationLanguageLists
}

function validateLanguageCode(languageCode:LanguageCode)
{
    return languageCode!==null && languageCode!==undefined && typeof(languageCode)==='string' && LanguageCodes.includes(languageCode);
}

// No duplicates
function validateLanguageCodeList(list:LanguageCode[])
{
    return list 
        && list.every(l => validateLanguageCode(l)) 
        && basicValidation.arrayStringsAreUnique(list);
}

// No duplicates, identical lists
function validateLanguageCodeLists(lists:LanguageCode[][])
{
    const getLanguageListIdentifier = (list:LanguageCode[]) =>
    {
        return list.sort().join('|');
    }

    if(lists.length === 0)
        return true;

    if(!validateLanguageCodeList(lists[0]))
        return false;

    for(let i=1; i<lists.length; i++){

        if(getLanguageListIdentifier(lists[0]) !== getLanguageListIdentifier(lists[i]))
            return false;
    }
    return true;
}



function validateTranslationLanguage(itm:{languageCode:LanguageCode})
{
    return itm && validateLanguageCode(itm.languageCode);
}


function validateTranslationLanguageList(list:{languageCode:LanguageCode}[])
{
    return list && validateLanguageCodeList(list.map(l => l.languageCode));
}

function validateTranslationLanguageLists(list:{languageCode:LanguageCode}[][])
{
    return list && validateLanguageCodeLists(list.map(l1 => l1.map(l2 => l2.languageCode)));
}